
function keysToCamel(obj) {
  if (Array.isArray(obj)) {
    return obj.map(keysToCamel)
  } else if (isPlainObject(obj)) {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        toCamelCase(key),
        keysToCamel(value)
      ])
    )
  }
  return obj
}

function isPlainObject(obj) {
  if (typeof obj !== "object" || obj === null) return false
  const proto = Object.getPrototypeOf(obj)
  return proto === Object.prototype || proto === null
}

function toCamelCase(str) {
  if (!str || str.includes("-")) return str

  const parts = str.split("_")
  if (parts.length === 1) return str

  const first = parts.shift()
  const rest = parts.map(part =>
    part.charAt(0).toUpperCase() + part.slice(1)
  ).join("")
  return first + rest
}

export default keysToCamel
